import React, { ReactNode } from 'react';
import { Box, SxProps } from '@mui/material';
import Background from './Background';

type BaseProps = {
  image?: string | undefined;
  children: ReactNode;
  sx?: SxProps;
};

const BasePage: React.FC<BaseProps> = ({
  children,
  image,
}) => {
  return (
    <Box
      width="100vw"
      height="100%"
      minHeight="100vh"
      sx={{
        overflowX: 'hidden',
        position: 'relative',
        backgroundColor: '#1C1814',
      }}
    >
      <Background image={image} />
      <Box px={1} width="100%" minHeight="100vh" mx="auto" position="relative" zIndex={1}>
        {children}
      </Box>
    </Box>
  );
};

export default BasePage;
